import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import { removeItem, updateItem } from '@/lib/cart.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { remove, decrease, increase, quantity } = zelektor(node)
    const id = node.dataset.id


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    remove.addEventListener('click', () => {
        removeItem(id)
    })

    decrease.addEventListener('click', (e) => {
        e.preventDefault()
        updateItem({id, qty: parseInt(quantity.value) - 1})
    })

    increase.addEventListener('click', (e) => {
        e.preventDefault()
        updateItem({id, qty: parseInt(quantity.value) + 1})
    })
})